/* eslint-disable @nx/enforce-module-boundaries */
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, catchError, map } from 'rxjs';

import { LinkedItem, LinkedItemTypeEnum } from '@ninety/platform/models/linked-items/linked-item-type-enum';
import { LinkedItems } from '@ninety/platform/models/linked-items/linked-items-response.model';
import { ErrorService, extractValueFromStore } from '@ninety/platform/services';
import { selectCompanyId } from '@ninety/platform/state';

@Injectable({
  providedIn: 'root',
})
export class LinkedItemsService {
  private readonly linkedItemsApi = '/api/v4/linked-items';

  http = inject(HttpClient);
  store = inject(Store);
  errorService = inject(ErrorService);

  getLinkedItems(itemType: LinkedItemTypeEnum, itemId: string): Observable<LinkedItems> {
    const companyId = extractValueFromStore(this.store, selectCompanyId);
    // Note: "all" was added to the GET URL path to fix an issue with GET and DELETE having the similar starting URL path.
    return this.http.get<LinkedItems>(`${this.linkedItemsApi}/all/${companyId}/${itemType}/${itemId}?limit=1000`).pipe(
      map(result => result),
      catchError((e: unknown) => this.errorService.notify(e, `Could not get linked items. Please try again.`))
    );
  }

  deleteLinkedItem(linkId: string): Observable<void> {
    const companyId = extractValueFromStore(this.store, selectCompanyId);
    return this.http.delete<void>(`${this.linkedItemsApi}/${companyId}/${linkId}`).pipe(
      map(result => result),
      catchError((e: unknown) => this.errorService.notify(e, `Could not delete linked item. Please try again.`))
    );
  }

  addLinkedItems(linkedItems: LinkedItem[], fromType: LinkedItemTypeEnum, fromId: string): Observable<LinkedItems> {
    const companyId = extractValueFromStore(this.store, selectCompanyId);
    return this.http
      .post<LinkedItems>(`${this.linkedItemsApi}/${companyId}`, {
        linkedItems: linkedItems,
        ...(fromType ? { fromType } : {}),
        ...(fromId ? { fromId } : {}),
      })
      .pipe(
        map(result => result),
        catchError((e: unknown) => this.errorService.notify(e, `Could not create linked items. Please try again.`))
      );
  }
}
